import React from 'react';
import {
  BottomNavigation,
  BottomNavigationButton,
  MobileMenuContainer,
  SideMenuStyle,
  SideMenuBackground,
  SideMenuFirstLevelStyle,
  MobileSubMenuStyle,
  BottomSearch,
} from '../../Styles/MobileMenu';
import {
  coursesIcon,
  moreIcon,
  profileIcon,
  searchIcon,
} from '../../../../Assets/images/Icons';
import { WithTranslation, withTranslation } from 'react-i18next';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import UserProfile from '../UserProfile/UserProfile';
import { IUser } from '../../Interfaces/IUser';
import { GITHUB_ACCOUNT_LINKED } from '../../../CourseInstance/Constraints';
import { SearchPortal } from '../../Styles/NavBar';
import { PrimaryModernButton } from '../../../../__core/Styles/Buttons/PrimaryModernButton';
import AppConfig from '../../../../Configs/AppConfig';
import { AppConfigType } from '../../../../Configs/AppConfigType';

type MobileMenuProps = WithTranslation &
  RouteComponentProps & {
    user: IUser;
    refreshUserData: () => void;
  };
type MobileMenuState = {
  showSideMenu: boolean;
  showProfileSideMenu: boolean;
  showSearch: boolean;
};

const { COURSES_CATALOG_URL = '' } = AppConfig as AppConfigType;

class MobileMenu extends React.Component<MobileMenuProps, MobileMenuState> {
  getInitStateForSideMenu = (): boolean => {
    const {
      location: { hash },
    } = this.props;

    return hash === GITHUB_ACCOUNT_LINKED;
  };
  state = {
    showSideMenu: this.getInitStateForSideMenu(),
    showProfileSideMenu: this.getInitStateForSideMenu(),
    showSearch: false,
  };

  toggleSideMenu = (): void =>
    this.setState((state) => ({
      showSideMenu: !state.showSideMenu,
      showProfileSideMenu: false,
    }));

  closeSideMenu = (): void =>
    this.setState({
      showSideMenu: false,
    });

  openProfileSideMenu = (): void =>
    this.setState({
      showProfileSideMenu: true,
    });

  closeProfileSideMenu = (): void =>
    this.setState({
      showProfileSideMenu: false,
    });

  toggleShowSearch = (): void =>
    this.setState((state) => ({
      showSearch: !state.showSearch,
    }));

  render(): React.ReactElement {
    const { t, user, refreshUserData } = this.props;
    const { showSideMenu, showProfileSideMenu, showSearch } = this.state;

    return (
      <MobileMenuContainer>
        <SideMenuBackground show={showSideMenu} />
        <SideMenuStyle show={showSideMenu}>
          <SideMenuFirstLevelStyle className="first-level">
            <div
              id="open-profile-menu-button"
              className="profile"
              onClick={this.openProfileSideMenu}
            >
              {profileIcon} <span>{t('Profile')}</span>
            </div>
          </SideMenuFirstLevelStyle>
          <div id="course-data-portal" className="second-level" />
        </SideMenuStyle>

        <BottomNavigation show={!showSearch}>
          <BottomNavigationButton
            as={NavLink}
            to="/courses"
            id="course-menu-item"
            onClick={() => {
              this.closeSideMenu();
              this.closeProfileSideMenu();
            }}
          >
            {coursesIcon}
            <div>{t('Courses')}</div>
          </BottomNavigationButton>
          {COURSES_CATALOG_URL && (
            <BottomNavigationButton
              as="a"
              href={COURSES_CATALOG_URL}
              target="_blank"
              rel="noreferrer"
              id="course-catalog"
              onClick={() => {
                this.closeSideMenu();
                this.closeProfileSideMenu();
              }}
            >
              {moreIcon}
              <div>{t('Offer')}</div>
            </BottomNavigationButton>
          )}
          <BottomNavigationButton
            id="search-menu-item"
            onClick={() => {
              this.closeSideMenu();
              this.toggleShowSearch();
            }}
          >
            {searchIcon}
            <div>{t('Search')}</div>
          </BottomNavigationButton>
          <BottomNavigationButton
            id="more-menu-item"
            active={showSideMenu}
            onClick={this.toggleSideMenu}
          >
            {moreIcon}
            <div>{t('More')}</div>
          </BottomNavigationButton>

          <BottomSearch show={showSearch} id="bottom-search">
            <SearchPortal id="search-portal-mobile" />
            <PrimaryModernButton onClick={this.toggleShowSearch}>
              X
            </PrimaryModernButton>
          </BottomSearch>
        </BottomNavigation>

        <MobileSubMenuStyle show={showProfileSideMenu}>
          <h2 onClick={this.closeProfileSideMenu}>
            {profileIcon} {t('Profile')}
          </h2>
          <hr />

          <UserProfile user={user} refreshUserData={refreshUserData} />
        </MobileSubMenuStyle>
      </MobileMenuContainer>
    );
  }
}

export default withTranslation()(withRouter(MobileMenu));
